import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import { profilePhotouploadDir } from '../../config';
import { Button, Row, Col, Panel } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ProfilePhoto.css';
import FontAwesome from 'react-icons/fa';

// Redux
import { connect } from 'react-redux';
import { doRemoveProfilePicture } from '../../actions/manageUserProfilePicture';

// Component
import DropZone from './DropZone';
import Avatar from '../Avatar';
import Loader from '../Loader';
// Asset
import defaultPic from './defaultPic.png';

// Locale
import messages from '../../locale/messages';
import { ViewBox, Text } from '../../components_new/common';
import FormBox from '../../components_new/common/FormBox';
import { getp } from '../../helpers/getProp';

class ProfilePhotoUploadForm extends React.Component {
  static propTypes = {
    profilePhotoLoading: PropTypes.bool,
    formatMessage: PropTypes.func,
    doRemoveProfilePicture: PropTypes.func.isRequired,
    profilePictureData: PropTypes.shape({
      loading: PropTypes.bool,
      userAccount: PropTypes.shape({
        picture: PropTypes.string.isRequired,
      }),
    }),
    small: PropTypes.bool,
  };

  static defaultProps = {
    profilePictureData: {
      loading: true,
    },
    profilePhotoLoading: false,
    small: false,
  };

  render() {
    const {
      profilePictureData: { loading, userAccount },
      doRemoveProfilePicture,
      small,
    } = this.props;
    const { profilePhotoLoading } = this.props;
    const { formatMessage } = this.props.intl;
    const picture = userAccount && userAccount.picture;

    if (small) {
      return (
        <div>
          {picture && (
            <Loader show={profilePhotoLoading} type={'page'}>
              <div className={cx(s.profilePic, s.picRound)}>
                {loading ? (
                  'Loading...'
                ) : (
                  <Avatar
                    isUser
                    height={200}
                    width={200}
                    className={s.profileAvatar}
                  />
                )}
              </div>
            </Loader>
          )}
          {!picture && (
            <DropZone
              data={userAccount}
              renderButton={() => (
                <div className="b-1 b-coolGrayLight brad-full p-l f-cc f-rows">
                  <i className="fal fa-plus fa-5x coolGrayLight" />
                  <Text coolGrayLight clickable>
                    Drag photo here or
                  </Text>
                  <Text coolGrayLight clickable>
                    click to upload
                  </Text>
                </div>
              )}
            />
          )}
        </div>
      );
    }
    return (
      <FormBox header="Profile photo">
        <Row>
          <Col xs={12} sm={6} md={4} lg={4} className={s.textAlignCenter}>
            <Loader show={profilePhotoLoading} type={'page'}>
              <div className={s.picContainer}>
                <div className={cx(s.profilePic, s.picRound)}>
                  {loading ? (
                    'Loading...'
                  ) : (
                    <Avatar
                      isUser
                      height={200}
                      width={200}
                      className={s.profileAvatar}
                    />
                  )}
                </div>
                {!loading && userAccount && userAccount.picture && (
                  <a
                    href="javascript:void(0);"
                    onClick={() => doRemoveProfilePicture(userAccount.picture)}
                  >
                    <i className={`${s.trashIcon} fa fa-trash`} />
                  </a>
                )}
              </div>
            </Loader>
          </Col>

          <Col xs={12} sm={6} md={8} lg={8}>
            <p className={cx('hidden-md hidden-lg')}>&nbsp;</p>
            <p className={s.textMuted}>
              <FormattedMessage {...messages.profilePhotoInfo} />
            </p>

            <Col
              xs={12}
              sm={12}
              md={4}
              lg={4}
              className={cx(
                s.spaceTop2,
                s.fullWidth,
                s.button,
                s.btnPrimaryBorder,
              )}
            >
              <DropZone
                data={userAccount}
                defaultMessage={formatMessage(messages.dropzoneUpload)}
              />
            </Col>
          </Col>
        </Row>
      </FormBox>
    );
  }
}

const mapState = state => ({
  profilePhotoLoading: state.account.profilePhotoLoading,
});

const mapDispatch = {
  doRemoveProfilePicture,
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
  graphql(
    gql`
      query {
        userAccount {
          picture
        }
      }
    `,
    {
      name: 'profilePictureData',
      options: {
        ssr: false,
      },
    },
  ),
)(ProfilePhotoUploadForm);



// WEBPACK FOOTER //
// ./src/components/ProfilePhoto/ProfilePhoto.js